import createAreaCustomerForm from './createAreaFormModel';
const {
  formField: {
    // DATOS AREA 
    name,
    description,
  } 
} = createAreaCustomerForm;

export default {
  [name.name]: '',
  [description.name]: '',
};

